import { useDataTable } from '../../table/DataTable';

const RefreshButton = () => {
  const { setRefreshTimestamp } = useDataTable();

  const handleRefresh = () => {
    setRefreshTimestamp(Date.now());
  };

  return (
    <button aria-label="Atualizar dados" className="btn btn-light-primary" type="button" onClick={handleRefresh}>
      <svg
        aria-hidden="true"
        className="bi bi-arrow-clockwise"
        fill="currentColor"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" fillRule="evenodd" />
        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
      </svg>
    </button>
  );
};

export default RefreshButton;
